var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHowToPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.518 12.62C10.518 11.2 11.478 10.54 12.138 10.08C12.498 9.84 12.758 9.66 12.758 9.44C12.758 9.2 12.598 9.02 11.978 9.02C11.458 9.02 10.738 9.34 10.238 9.86L7.99805 7.28C9.15805 6.04 10.878 5.46 12.438 5.46C15.138 5.46 16.838 6.7 16.838 8.68C16.838 10.34 15.858 11.1 15.038 11.72C14.478 12.14 13.998 12.5 13.998 13.06C13.998 13.4 14.118 13.68 14.218 13.8L11.058 14.52C10.738 14.08 10.518 13.42 10.518 12.62ZM10.418 17.1C10.418 15.94 11.398 14.96 12.558 14.96C13.718 14.96 14.698 15.94 14.698 17.1C14.698 18.26 13.718 19.24 12.558 19.24C11.398 19.24 10.418 18.26 10.418 17.1Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHowToPlay);
export default __webpack_public_path__ + "static/media/icon-how-to-play.abea4a9dc9f4e7e8d048f7d4e9d523ea.svg";
export { ForwardRef as ReactComponent };